import React from 'react'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import { getTheme } from '../../../redux/user/userSlice'
import { selectStyleDark, selectStyleLight } from '../../../utils/sharedCareTeamLogic'

export default function CareDxDropdown({ limit, encounterDX = [], careDx = [], setCareDx }) {
  const theme = useSelector(getTheme)

  return (
    <div className={'CMDXDropdown mb-2'}>
      <Select
        isMulti
        closeMenuOnSelect={careDx.length + 1 >= limit}
        styles={theme === 'light' ? selectStyleLight : selectStyleDark}
        placeholder={'Select DX' + (limit === 2 ? 's' : '')}
        options={encounterDX.map((dx) => ({
          ...dx,
          value: dx.code,
          label: `${dx.code}- ${dx.description}`,
        }))}
        onChange={(newDx) => {
          setCareDx(newDx.map((dx) => dx.code))
        }}
        value={careDx.map((code) => {
          const dxDetails = encounterDX.find((dx) => dx.code === code) || {}
          return {
            ...dxDetails,
            value: code,
            label: `${code}- ${dxDetails.description || ''}`,
          }
        })}
        isOptionDisabled={() => careDx?.length >= limit}
      />
      <div style={{ fontSize: '12px' }}>
        {limit === 1 &&
          'Choose one active, high-risk chronic, or complex, condition that is expected to last at least 3 months with the highest chance of rehospitalization, morbidity or mortality that requires a focused care plan'}
        {limit === 2 &&
          'Choose two active, high-risk chronic conditions that are expected to last at least one year that require a focused care plan'}
      </div>
    </div>
  )
}
